import { twMerge } from 'tailwind-merge';
import type { HtmlElementProps } from '@/types';
import { classes } from './utils';

export type DialogActionsProps = HtmlElementProps;

export default function DialogActions({
  className,
  ...props
}: DialogActionsProps) {
  return (
    <div className={twMerge(classes.dialogActions, className)} {...props} />
  );
}
